import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const LoadingContainer = styled.div<{ height: string }>`
  height: ${({ height }) => height};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.color.designSystem.grey20};
  border-radius: ${theme.borderRadius.medium};
`;
